<template>
  <div class="group-filter-bg px-md-4 py-md-4">
    <div class="row pt-0 mr-lg-4 justify-content-between">
      <!-- Group Filter -->
      <div
        :class="`col-sm-6 col-xl-${col}`"
        v-if="$route.path != '/personalTasks'"
      >
        <div class="group-filter">
          <div class="form-group">
            <select class="form-control" v-model="groupName">
              <option value="" selected>
                {{ $t("global.groupPlaceholder") }}
              </option>
              <option
                v-for="(group, index) in groups"
                :value="group.reference"
                :key="index"
              >
                {{ group.name }}
              </option>
            </select>
            <div class="select-down">
              <img
                class="select-down__icon"
                src="@/assets/images/down-arrow.svg"
                alt="Arrow Icon"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Report for Filter -->
      <div :class="`col-sm-6 col-xl-${col} mb-3 mb-md-0`">
        <div class="d-flex common-filter">
          <div class="p-2 icon">
            <i class="far fa-calendar"></i>
          </div>
          <div>
            <d-datepicker
              v-model="dueDate"
              :placeholder="$t('task.create.dueDate')"
              :language="fr"
              small
              typeable
            />
          </div>
        </div>
      </div>
      <!-- Date added -->
      <div :class="`col-sm-6 col-xl-${col} mb-3 mb-xl-0`">
        <div class="d-flex common-filter">
          <div class="p-2 icon">
            <i class="far fa-calendar"></i>
          </div>
          <div>
            <d-datepicker
              v-model="creationDate"
              :placeholder="$t('task.creationDate')"
              :language="fr"
              small
              typeable
            />
          </div>
        </div>
      </div>
      <!-- Apply Button -->
      <div :class="`only-desk-top col-sm-6 col-xl-${col} mb-3 mb-md-0 d-flex`">
        <div class="task-manager-apply">
          <button class="task-manager-btn" @click="refresh()">
            {{ $t("global.reset") }}
          </button>
        </div>
        <div class="task-manager-apply">
          <button class="task-manager-btn" @click="saveSearch()">
            {{ $t("global.apply") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import groups from "@/data/groups/Groups";
import { fr } from "vuejs-datepicker/dist/locale";
import TaskHelper from "../../helper/TaskHelper";

export default {
  data() {
    return {
      groups,
      groupName: "",
      dueDate: "",
      creationDate: "",
      hideGroupFilter: true,
      fr,
    };
  },

  mounted() {
    const currentUser = this.$store.state.user.informations;
  },

  computed: {
    col() {
      return this.hideGroupFilter ? 3 : 3;
    },
  },

  methods: {
    saveSearch() {
      const obj = {
        groupName: this.groupName,
        dueDate: this.dueDate,
        creationDate: this.creationDate,
      };
      this.$emit("saveSearch", obj);
    },

    refresh() {
      this.groupName = "";
      this.dueDate = "";
      this.creationDate = "";
      this.saveSearch();
      this.$root.$emit("createTask");
    },
  },
};
</script>
<style lang="scss">
.form-control {
  background-color: #fff !important;
}
.group-filter {
  position: relative;
  select {
    background: white !important;
    color: black !important;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4) !important;
    background-repeat: no-repeat;
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
  }
  .select-down {
    position: absolute;
    right: 10px;
    top: 5px;
    &__icon {
      width: 13px;
    }
  }
}
.task-manager-apply {
  .task-manager-btn {
    width: 110px;
    height: 36px;
    border: 0;
    background-color: #4f78e2;
    color: #fff;
    font-family: "SF-Pro-Text";
    border-radius: 3px;
    font-size: 14px;
    margin-right: 15px; //9
    outline: none;
  }
}
</style>
